<!-- Реализация пункта меню для панели навигации -->
<template>
    <b-link :to="to">
        <div class="menu-item">
            <div class="icon">
                <slot name="icon">
                    <b-icon-grid class="w-100 h-100" />
                </slot>
            </div>
            <div class="body">
                <div class="title">
                    <slot name="title">
                        <b>{{ title }}</b>
                    </slot>
                </div>
                <div class="description">
                    <slot name="description">
                        {{ description }}
                    </slot>
                </div>
            </div>
        </div>
    </b-link>
</template>

<script>
export default {
    name: 'NavsMenuItem',
    props: {
        to: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
$width: 300px;
$height: 100px;
$padding: 8px;

.menu-item {
    display: inline-block;
    position: relative;
    width: $width;
    height: $height;
    margin: 8px;
    padding: 8px;
    overflow: hidden;
    border: 1px solid #e7e7e7;

    &:hover {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    }

    .icon {
        position: absolute;
        left: $padding;
        top: $padding;
        width: $height;
        bottom: $padding;
    }

    .body {
        position: absolute;
        left: $height + $padding;
        top: $padding;
        right: $padding;
        bottom: $padding;
    }
}
</style>
